import React, { useCallback } from "react";
import {  useMobileOrientation } from 'react-device-detect'
import './returntomovies.css'
import { useFullscreen } from '../../hooks/useFullscreen'

export default function ReturnToMovies({ show }) {

      // Pause video when a mobile device is in portrait orientation
  const { isPortrait } = useMobileOrientation();
  const { requestFullscreen } = useFullscreen();
  
  const stopPropagation = useCallback((event) => {
    event.stopPropagation();
  }, []);
  
  const _onSubmit = useCallback(() => {
    // stopPropagation();
    requestFullscreen();
  }, []);
  
  
  const renderRotate = () => {
    const visibilityClassName = show ? 'visible' : 'invisible';
    return (
      <div className={`container-flex returntomovies ${visibilityClassName}`}>
        <div className="row h-100 justify-content-center align-items-center return-to-movies-container">
          <div className="col-12 text-center">
          <h1>RETURN TO TRAILERS</h1>
          <div className={"returntomovies-submit-container"} onMouseDown={stopPropagation} onClick={stopPropagation}>
            <button className={"btn-return"} onClick={_onSubmit}>
              <i className="material-icons md-48">play_arrow</i>
            </button>
          </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
    {isPortrait ? renderRotate() : null}
    { !isPortrait ? renderRotate() : null}
    </>
  );
}
